/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { takeLatest, all } from 'redux-saga/effects';

import {
  FetchRepositories,
  FETCH_NONCRITICAL_REPOSITORIES_DATA,
} from 'src/redux/dashboard/actions';

import { getDashboardRepositoryListBuildStatuses } from './get-repository-build-statuses';

export function* dashboardSagas() {
  yield all([
    takeLatest(
      [FetchRepositories.SUCCESS],
      getDashboardRepositoryListBuildStatuses
    ),
    takeLatest(
      [FETCH_NONCRITICAL_REPOSITORIES_DATA],
      getDashboardRepositoryListBuildStatuses
    ),
  ]);
}
